import {makeObservable, observable} from "mobx";

import {Kiwis} from "./kiwis";
import {StationDocument} from "./station-document";
import {PathUtils} from "../utils/path-utils";
import {StationDocumentsMapping} from "../config/kiwis-configuration";

export interface StationDocumentsProps {
    store: Kiwis;
    id: string;
}

export class StationDocuments {
    @observable id: string;
    store: Kiwis;

    constructor(props?: StationDocumentsProps) {
        makeObservable(this);
        if (props) {
            Object.assign(this, props);
        }
    }

    /**
     * Returns a flat Array of station documents of the categories specified in the config.
     * The document service returns the relative URLs of documents per category.
     * A category item may contain a single URL or an Array of URLs.
     * Document service sample response: https://data.monitron.ch/LU_Hydrometrie/stations.php
     *
     * @param config
     * @param baseUrl
     */
    getDocumentData(config: StationDocumentsMapping[], baseUrl: string): StationDocument[] {

        const docs: StationDocument[] = [];

        config.forEach((configItem: any) => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const documentData = this[configItem.propertyName];
            if (typeof (documentData) === "string") {

                // documentData is a single relative URL
                const url = PathUtils.joinPath(baseUrl, documentData);
                docs.push(new StationDocument({
                    label: configItem.label,
                    url,
                    isFirstOfCategory: true
                }));

            } else if (typeof (documentData) === "object") {

                // documentData is an array of relative URLs
                documentData.forEach((documentUrl: string, idx: number) => {

                    const url = PathUtils.joinPath(baseUrl, documentUrl);
                    docs.push(new StationDocument({
                        label: configItem.label,
                        url,
                        isFirstOfCategory: idx === 0
                    }));
                });
            }
        });

        return docs;
    }
}
